import axiosClient from "@/libs/axiosClient";

export const _getPrices = ({ groupName } = {}) => {
    return axiosClient.get(`/billing/prices?groupName=${groupName}`);
};

export const _createCustomer = ({ groupName, email }) => {
    return axiosClient.post(`/billing/customers?groupName=${groupName}`, { email });
};

export const _updateCustomer = ({ groupName, customerId, email } = {}) => {
    return axiosClient.patch(`/billing/customers/${customerId}?groupName=${groupName}`, { email });
};

export const _getCustomer = ({ groupName, customerId }) => {
    return axiosClient.get(`/billing/customers/${customerId}?groupName=${groupName}`);
};

export const _createCard = ({ groupName, customerId, card } = {}) => {
    return axiosClient.post(`/billing/customers/${customerId}/sources?groupName=${groupName}`, { card });
};

export const _deleteCard = ({ groupName, customerId, cardId } = {}) => {
    return axiosClient.delete(`/billing/customers/${customerId}/sources/${cardId}?groupName=${groupName}`);
};

export const _getCard = ({ groupName, customerId, cardId } = {}) => {
    return axiosClient.get(`/billing/customers/${customerId}/sources/${cardId}?groupName=${groupName}`);
};

export const _createSubscribe = ({
    groupName = "",
    customerId = "",
    priceId = "",
    trialPeriodDays = 0,
    quantity = 1,
    resourceName = "basic"
}) => {
    return axiosClient.post(`/billing/customers/${customerId}/subscriptions?groupName=${groupName}`, {
        priceId,
        trialPeriodDays,
        quantity,
        resourceName
    });
};

export const _deleteSubscribe = ({ groupName, customerId, subscriptionId } = {}) => {
    return axiosClient.delete(
        `/billing/customers/${customerId}/subscriptions/${subscriptionId}?groupName=${groupName}`
    );
};

export const _updateSubscribe = ({ groupName, customerId, priceId } = {}) => {
    return axiosClient.patch(`/billing/customers/${customerId}/subscriptions/${priceId}?groupName=${groupName}`);
};

export const _getSubscriptions = ({ groupName, customerId } = {}) => {
    return axiosClient.get(`/billing/customers/${customerId}/subscriptions?groupName=${groupName}`);
};

export const _createOrder = ({ groupName, subscriptions, tradeNo, token, payToken } = {}) => {
    return axiosClient.post(`/billing/ecpay/createOrder/?groupName=${groupName}`, {
        subscriptions,
        tradeNo,
        token,
        payToken
    });
};

export const _getCalculateUsageSummary = ({ groupName, firstDate, lastDate } = {}) => {
    return axiosClient.post(`/billing/calculate/UsageSummary?groupName=${groupName}`, {
        firstday: firstDate,
        lastday: lastDate
    });
};

export const _getInvoice = ({ invoiceID }) => {
    return axiosClient.get(`/billing/invoices?invoiceID=${invoiceID}`);
};

export const _payInvoice = ({ invoiceID, groupName }) => {
    return axiosClient.post(`/billing/invoices/pay?groupName=${groupName}`, { invoiceID });
};

export const _getCusInvoices = ({ groupName, customerId }) => {
    return axiosClient.get(`/billing/customers/invoice/${customerId}?groupName=${groupName}`);
};

export const _getAmount = ({ groupName }) => {
    return axiosClient.get(`/billing/amount?groupName=${groupName}`);
};

// export const _getMonthlyPayment = ({ groupName, time }) => {
//     return axiosClient.get(`/billing/amount/monthlypayment?groupName=${groupName}&time=${time}`);
// };

export const _getInvoicePDF = ({ groupName, number, invoiceId }) => {
    return axiosClient.get(`/billing/customers/invoice/PDF/${number}/${invoiceId}?groupName=${groupName}`, {
        responseType: "arraybuffer"
    });
};

export const _getDifferencePrice = ({ groupName, subscriptionId }) => {
    return axiosClient.get(`/billing/amount/differencePrice/${subscriptionId}?groupName=${groupName}`);
};

export const _updateCoupons = ({ groupName, subscriptionId, couponCode } = {}) => {
    return axiosClient.patch(`/billing/coupons/${subscriptionId}?groupName=${groupName}`, { couponCode });
};



// WEBPACK FOOTER //
// ./src/api/billing.js